var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 678.831,
    height: 141.372,
    viewBox: "0 0 678.831 141.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.765,
    y1: -1.169,
    x2: 0.921,
    y2: 1.252,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-lara",
    transform: "translate(-79.97 -19.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Design",
    transform: "translate(80 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M84.5,84.4a1.343,1.343,0,0,1-.7,1.4L30.4,120.6l-5,3.2a1.209,1.209,0,0,1-1.4-.1,107.831,107.831,0,0,1-9.7-10.6.792.792,0,0,1,.1-1.1l.1-.1,4.7-3,61.4-40a1.48,1.48,0,0,1,2.1.4,1.445,1.445,0,0,1,.2.7Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M141.3,71.6c-.5,38.1-32.7,69.8-70.9,69.7a69.8,69.8,0,0,1-37.7-11.1.618.618,0,0,1-.2-.7c0-.1.1-.1.2-.2l5.3-3.5L78.9,99.1a1.48,1.48,0,0,1,2.1.4,1.421,1.421,0,0,1,.2.6l1.4,11.7a1.343,1.343,0,0,1-.7,1.4l-28,18.3a.494.494,0,0,0-.1.7c.1.1.2.2.3.2A64.074,64.074,0,1,0,87.2,8.6,66.068,66.068,0,0,0,69.5,6.4c-34.4.7-63.1,29.9-63,64.4A64.792,64.792,0,0,0,8,84.6a.548.548,0,0,0,.6.4c.1,0,.1,0,.2-.1l73-47.6a1.48,1.48,0,0,1,2.1.4,1.421,1.421,0,0,1,.2.6l2.3,17.8a1.57,1.57,0,0,1-.7,1.5L15.5,103.4l-4.6,3a.889.889,0,0,1-1.3-.3h0A67.525,67.525,0,0,1,2.4,89,70.639,70.639,0,0,1,138.8,52.2,74.283,74.283,0,0,1,141.3,71.6Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M255.3,86V41.9H265V77.2h22V86Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M328.8,86l-4-9.9H306.2l-4,9.9h-9.9l18.9-44.4h8.9L339,86ZM315.5,53.2l-5.9,14.3h11.7Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M374.2,86l-9.4-14.1h-7.6V86h-9.7V41.9h20.2c5.2,0,9.3,1.3,12.3,3.8,2.9,2.6,4.4,6.1,4.4,10.7v.1a13.857,13.857,0,0,1-2.6,8.7,14.784,14.784,0,0,1-6.8,4.9L385.6,86Zm.2-29a5.625,5.625,0,0,0-2-4.7,9.1,9.1,0,0,0-5.6-1.6h-9.6V63.4H367a8.22,8.22,0,0,0,5.5-1.7,5.548,5.548,0,0,0,1.9-4.5V57Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M427.5,86l-4-9.9H404.9l-4,9.9H391l18.9-44.4h8.9L437.7,86ZM414.2,53.2l-5.9,14.3H420Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M502,82.2a20.687,20.687,0,0,1-8.8,4.1,26.121,26.121,0,0,1-5.8.5,22.972,22.972,0,0,1-16.2-6.6,20.911,20.911,0,0,1-4.7-7.2,23.9,23.9,0,0,1-1.7-8.9V64a23.9,23.9,0,0,1,1.7-8.9,20.911,20.911,0,0,1,4.7-7.2,21.393,21.393,0,0,1,7.2-4.9,23.371,23.371,0,0,1,9.3-1.8,31.5,31.5,0,0,1,5.6.5,20.637,20.637,0,0,1,4.6,1.4,19.669,19.669,0,0,1,3.8,2.1A22.2,22.2,0,0,1,505,48l-6.2,7.1a22.152,22.152,0,0,0-5.3-3.7,13.2,13.2,0,0,0-6-1.3,12.273,12.273,0,0,0-5.1,1.1,12.077,12.077,0,0,0-4.1,3,12.226,12.226,0,0,0-2.6,4.4,15.527,15.527,0,0,0-.9,5.3V64a16.105,16.105,0,0,0,.9,5.4,12.834,12.834,0,0,0,2.6,4.4,13.141,13.141,0,0,0,4,3,12.742,12.742,0,0,0,5.2,1.1,13.76,13.76,0,0,0,6.4-1.4,24.514,24.514,0,0,0,5.2-3.8l6.2,6.2A20.6,20.6,0,0,1,502,82.2Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M547.8,86l-4-9.9H525.2l-4,9.9h-9.9l18.9-44.4h8.9L557.9,86ZM534.4,53.2l-5.9,14.3h11.7Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M600,64a15.072,15.072,0,0,1-3.8,4.9,15.374,15.374,0,0,1-5.7,2.9,22.792,22.792,0,0,1-7,1h-7.4V86h-9.7V41.9h18a22.5,22.5,0,0,1,7.1,1.1,15.453,15.453,0,0,1,5.3,3.1,13.311,13.311,0,0,1,3.3,4.8,15.581,15.581,0,0,1,1.2,6.2v.1A15.875,15.875,0,0,1,600,64Zm-8.5-6.7a6.142,6.142,0,0,0-2.1-5,9.1,9.1,0,0,0-5.8-1.7h-7.5V64.1h7.7a8.024,8.024,0,0,0,5.7-1.9,6.568,6.568,0,0,0,2-4.8v-.1Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M610.7,86V41.9h9.7V86Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M653.1,50.8V86h-9.7V50.8H630V41.9h36.5v8.9H653.1Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M708.4,86l-4-9.9H685.8l-4,9.9h-9.9l18.9-44.4h8.9L718.6,86ZM695.1,53.2l-5.9,14.3h11.7Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M727.1,86V41.9h9.7V77.2h22V86Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M271.617,135.087h-.2l-10.9-16.4v24.96H254.4V108.7h6.52l10.6,16.5,10.6-16.5h6.52v34.944h-6.113V118.582Z",
    transform: "translate(0 0.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M344.672,143.648h-6.52l-3.566-8.456h-16.5l-3.566,8.456H308.2L323.584,108.5h5.705Zm-18.338-27.813-6.011,13.957h12.022Z",
    transform: "translate(1.011 0.006)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M388.451,108.7h6.113v34.944H389.47l-19.357-24.858v24.858H364V108.7h5.705l18.644,24.145V108.7Z",
    transform: "translate(2.059 0.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M450.472,143.648h-6.52l-3.566-8.456h-16.5l-3.566,8.456H414L429.384,108.5h5.705Zm-18.338-27.813-6.011,13.957h12.022Z",
    transform: "translate(2.998 0.006)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M496.148,140.9a17.418,17.418,0,0,1-3.362,1.732,24.464,24.464,0,0,1-3.871,1.223,20.62,20.62,0,0,1-4.381.408,19.339,19.339,0,0,1-7.437-1.324,15.951,15.951,0,0,1-5.705-3.77,16.136,16.136,0,0,1-3.668-5.705,20.616,20.616,0,0,1-1.324-7.131,18.183,18.183,0,0,1,5.094-12.837,17.15,17.15,0,0,1,5.705-3.871,18.692,18.692,0,0,1,7.233-1.426,25.9,25.9,0,0,1,4.177.306,17.21,17.21,0,0,1,3.464.917c1.019.408,2.038.917,3.056,1.426a23.873,23.873,0,0,1,2.751,2.038l-3.871,4.686a13.279,13.279,0,0,0-2.038-1.528,15.743,15.743,0,0,0-2.241-1.223,10.465,10.465,0,0,0-2.547-.713,25.819,25.819,0,0,0-3.056-.306,9.65,9.65,0,0,0-4.483,1.019,10.21,10.21,0,0,0-3.566,2.649,13.04,13.04,0,0,0-2.445,3.973,12.522,12.522,0,0,0-.917,4.788,15.537,15.537,0,0,0,.815,4.992,11.326,11.326,0,0,0,2.445,3.973,10.989,10.989,0,0,0,3.77,2.649,12.312,12.312,0,0,0,4.89.917,14.115,14.115,0,0,0,4.686-.713,13.134,13.134,0,0,0,3.77-1.936v-6.622h-8.965v-5.3H499v14.67A28.865,28.865,0,0,1,496.148,140.9Z",
    transform: "translate(3.982)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M546.277,114.2H526.513v8.965h17.523v5.5H526.513v9.373h19.968v5.5H520.4V108.6h25.877Z",
    transform: "translate(4.997 0.008)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M584.717,135.087h-.2l-10.9-16.4v24.96H567.5V108.7h6.52l10.6,16.5,10.6-16.5h6.52v34.944h-6.113V118.582Z",
    transform: "translate(5.881 0.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M650.077,114.2H630.313v8.965h17.523v5.5H630.313v9.373h19.968v5.5H624.2V108.6h25.877Z",
    transform: "translate(6.946 0.008)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M695.649,108.7h6.113v34.944h-5.094l-19.255-24.858v24.858H671.3V108.7h5.705l18.644,24.145V108.7Z",
    transform: "translate(7.831 0.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M739.019,143.644H732.8V114.405H721.7V108.7h28.322v5.705h-11.1v29.239Z",
    transform: "translate(8.778 0.009)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae8caded942aa004c0f79b403fc3829c.svg";
export { ForwardRef as ReactComponent };